/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a"
  }, _provideComponents(), props.components);
  return React.createElement(_components.p, null, React.createElement(_components.a, {
    href: "https://www.youtube.com/watch?v=OJraGVZqAkk&list=TLGGv_YDVeTVY3kwNzA1MjAyNQ&t=8s"
  }, "Digital twin"), " technology is reshaping the future of engineering at Louisiana State University. Students enrolled in the university's digital twin program are uniquely positioned to advance the field through cross-disciplinary collaboration and given to opportunity to solve problems aided by the technology. Congratulations to everyone in DMAE at LSU who were involved!");
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
